import React from "react";
import { TooltipProps } from "@mui/material";
import {
  CustomTooltip,
  StyledTableCell,
  StyledTableRow,
} from "../styled_components";

interface TableRowContentProps {
  row: Record<string, string>;
  isDisabled: boolean;
  onClick: () => void;
}

const DEFAULT_TOOLTIP_PLACEMENT: TooltipProps["placement"] = "top";
const columns: {
  field: string;
  width?: string;
  tooltipPlacement?: TooltipProps["placement"];
}[] = [
  { field: "column_one" },
  { field: "column_two" },
  { field: "column_three" },
  { field: "column_four", tooltipPlacement: "auto-start" },
  { field: "column_five" },
  { field: "column_six" },
];

const TableRowContent: React.FC<TableRowContentProps> = ({
  row,
  isDisabled,
  onClick,
}) => {
  return (
    <StyledTableRow
      onClick={onClick}
      className={isDisabled ? "disabled-row" : ""}
      aria-disabled={row.column_five === "Cancelled"}
    >
      {columns.map(({ field, tooltipPlacement }) => {
        // Specific logic for column_five
        if (field === "column_five") {
          const value = row[field];
          const specialStatuses = ["Decommissioned", "Cancelled", "Failed"];
          let tooltipText = "";
          let displayText = "";

          if (specialStatuses.includes(value)) {
            tooltipText = value;
            displayText = value;
          } else if (value && !isNaN(Number(value)) && Number(value) > 0) {
            // If it's a positive number (or string representing one), show "Score: value"
            tooltipText = `Score: ${value}`;
            displayText = `Score: ${value}`;
          } else {
            // Otherwise (e.g., empty, 0, non-numeric string not in specialStatuses),
            // display the value as is, tooltip is the value or empty string
            tooltipText = value || "";
            displayText = value || "";
          }

          return (
            <StyledTableCell key={field}>
              <CustomTooltip
                title={tooltipText}
                placement={tooltipPlacement || DEFAULT_TOOLTIP_PLACEMENT}
              >
                <span>{displayText}</span>
              </CustomTooltip>
            </StyledTableCell>
          );
        } else {
          return (
            <StyledTableCell key={field}>
              <CustomTooltip
                title={row[field] || ""}
                placement={tooltipPlacement || DEFAULT_TOOLTIP_PLACEMENT}
              >
                <span>{row[field]}</span>
              </CustomTooltip>
            </StyledTableCell>
          );
        }
      })}
    </StyledTableRow>
  );
};

export default TableRowContent;
